export default __webpack_public_path__ + "static/media/about2.02a90a23.png";